import React from 'react';

const userAuthorityMappingFormModal = React.lazy(() => import('../components/FormModal'));
const userAuthorityMappingModalRegistry = {
    core_userAuthorityMappingId: userAuthorityMappingFormModal
};
export default userAuthorityMappingModalRegistry;
